export const DEFAULT_ROW_HEADER_WIDTH = '14rem';
export const DEFAULT_COLUMN_MIN_WIDTH = '12rem';

export const ROW_HEADER_COLUMN_ID = '__matrix_row_header__';

export const STICKY_HEADER_Z_INDEX = 20;
export const STICKY_BODY_Z_INDEX = 10;

export const HEADER_ROW_INDEX = 1;
